
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-onchange */
import React, { useState, useEffect, useRef } from 'react';
import router, { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { useSelect } from 'downshift';
import PropTypes from 'prop-types';
import styles from './GlobalLanguageSelection.module.scss';
import { getLanguageDisplayName } from '../../utils/i18n';
import { getLocaleFromApi, setLocaleToApi } from '../../utils/localeUtils';

import { locales } from '../../../i18n';

const GlobalLanguageSelection = ({ isPreview = false }) => {
  const nextRouter = useRouter();
  const pathname = nextRouter ? nextRouter.pathname : '/';
  const asPathName = nextRouter ? nextRouter.asPath : '/';
  const { t, lang } = useTranslation();
  const [Open, setIsOpen] = useState(false);
  const [showButton, setShowButton] = useState(true)
  const wrapperRef = useRef(null);
  const regex = new RegExp(`(^/${lang})`, 'g');

  const strippedPath = pathname.replace(regex, '');
  const path = strippedPath === '' ? '/' : strippedPath;

  const strippedAsPath = asPathName.replace(regex, '');
  let asPath = strippedAsPath === '' ? '/' : strippedAsPath;

  const handleSelectedLanguageChange = async ({ selectedItem: language }) => {
    console.log("language-->", language)
    if (window.coveoua) {
      window.coveoua("init", process.env.ANALYTICS_API_KEY, process.env.ANALYTICS_ENDPOINT);
      coveoua("send", "pageview");
    }

    asPath = asPath.replace(/[?&]fallback=true/g, '').replace(/[?&]$/, '');
    if (!language || language === lang) return;

    // Set the locale using the API
    const success = await setLocaleToApi(language);

    if (isPreview) {
      router.push(asPath, undefined, { locale: language === "en-US" ? language : language.toLowerCase() })
      router.events.on('routeChangeComplete', () => {
        router.reload()
      })
    } else {
      router.push(path, asPath, { locale: language === "en-US" ? language : language.toLowerCase() })
      router.events.on('routeChangeComplete', () => {
        router.reload()
      })
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
      ) {
        setIsOpen(false);
        setShowButton(true)
      }
    }
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const { isOpen, openMenu, getToggleButtonProps, getMenuProps, getItemProps, selectedItem, initialSelectedItem } = useSelect({
    items: locales,
    onSelectedItemChange: handleSelectedLanguageChange,
    id: 'GlobalLanguageSelect',
    selectedItem: lang || 'en-US',
    initialSelectedItem: lang || 'en-US',
    defaultSelectedItem: lang || 'en-US',
    initialHighlightedIndex: 0,
    className: styles.globalLanguageDropdown
  });

  return (
    <div data-testid="GlobalLanguageSelection" id="GlobalLanguageSelect-label" ref={wrapperRef}>
      {showButton && <button
        type="button"
        data-uxa-log="global_language_selection"
        data-uxa-interactions="click shown"
        {...getToggleButtonProps()}
        className={styles.globalLanguageDropdownToggle}
        title={t('common:formInputLabelGlobalSelectLanguage')}
        tabIndex="0"
        onClick={() => {
          setIsOpen(true)
          setShowButton(false)
          openMenu()
        }}>
        <span className={styles.globe}></span>
        <span className={styles.text}>{getLanguageDisplayName(selectedItem, t) ||
          getLanguageDisplayName(initialSelectedItem, t) ||
          t('common:formInputLabelGlobalSelectLanguage')}</span>
        <span className={styles.footerchevron}></span>
      </button>}

      <ul {...getMenuProps()} className={`${styles.globalLanguageDropdown} ${Open ? styles.dropdownOpen : styles.dropdownClose}`}>
        {
          locales.map((language, index) => (
            <li
              data-testid="GlobalLanguageSelection-select"
              key={`${language || index}`}
              {...getItemProps({ language, index })}
              data-uxa-log={`global_language_select_${language.toLowerCase().replace(/[^\w]/g, '_')}`}
              data-uxa-interactions="click shown"
              className={styles.globalLanguageDropdownItem}>
              <button className={styles.button}
                onClick={(e) => {
                  setIsOpen(false)
                  setShowButton(true)
                  handleSelectedLanguageChange({ selectedItem: language });
                }}
                onFocus={(e) => {
                  setIsOpen(true)
                }}
                onBlur={(e) => {
                  if (index === locales.length - 1) {
                    setShowButton(true)
                    setIsOpen(false)
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setIsOpen(false)
                    setShowButton(true)
                    handleSelectedLanguageChange({ selectedItem: language })
                  }
                }}
                title={getLanguageDisplayName(language, t)}
              >{getLanguageDisplayName(language, t)}
              </button>
            </li>

          ))}
      </ul>
    </div>
  );
};

GlobalLanguageSelection.propTypes = {
  isPreview: PropTypes.bool
};


export default GlobalLanguageSelection;
